// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookingSearchResponse

import { hydrateBooking, type Booking, type BookingApiResponse } from './booking.gen';

export type BookingSearchApiResponse = {
	items: BookingApiResponse[];
};

export type BookingSearch = {
	items: Booking[];
};

export function hydrateBookingSearch(data: BookingSearchApiResponse): BookingSearch {
	return {
		...data,
		items: data.items.map(hydrateBooking),
	};
}